import React from 'react';
import { getFieldComponent } from './fields';

export const Node = React.memo((props) => {
  const { node, workflow, onChange } = props;

  const handleFieldChange = (value, name) => {
    onChange((workflowData) => {
      return {
        ...workflowData,
        nodes: workflowData.nodes.map((item) => {
          if (item.id === node.id) {
            return {
              ...item,
              fields: item.fields.map((field) => {
                if (field.name === name) {
                  return { ...field, value };
                }
                return field;
              }),
            };
          }

          return item;
        }),
      };
    });
  };

  return (
    <div className="p-4 border-b border-[#efefef]">
      <div className="mb-3">
        <span className="text-[#2d2d2d] font-bold text-xs">{node.title}</span>
      </div>
      <div className="space-y-2">
        {node.fields.map((field, index) => {
          const FieldComponent = getFieldComponent(field.type);
          return <FieldComponent key={index} {...field} workflow={workflow} node={node} onChange={handleFieldChange} />;
        })}
      </div>
    </div>
  );
});
